import type { ObjectView } from "@cosmosai/api-client";

/** Specs whose name or reference contains the query, ignoring case. */
export const matching = (specs: ObjectView[], query: string | undefined): ObjectView[] => {
  const needle = query?.trim().toLowerCase();
  return needle
    ? specs.filter((s) => s.name.includes(needle) || s.ref.toLowerCase().includes(needle))
    : specs;
};
